<template>
<div>
    <BreadCrumb class="bread" :breads="['商品管理', '商品分组列表', title]"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">{{ title }}</span>
            <el-button class="addCustom" size="small" icon="el-icon-arrow-left" @click="goBack">
                返回列表
            </el-button>
        </div>
    </div>
    <div class="submit-form">
        <el-form :model="formData" ref="form" :rules="rules" :inline="true" size="small" label-width="90px">
            <div class="submit-form__search">
                <el-form-item label="分组名称" prop="name">
                    <el-input v-model="formData.name" maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="算法服务器" prop="third_lib_id">
                    <el-select v-model="formData.third_lib_id" @change="clearGoodsList" :disabled="$route.query.id">
                        <el-option v-for="(item, index) in thirdList" :key="index" :value="item.id" :label="item.type"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称" prop="name" v-if="this.$route.query.operate === 'look'">
                    <el-input v-model="shop_name" maxlength="30"></el-input>
                </el-form-item>
                <el-button size="small" @click="getData()" v-if="this.$route.query.operate === 'look'" type="primary">查询</el-button>
                <el-button size="small" @click="reset()" v-if="this.$route.query.operate === 'look'">重置</el-button>
            </div>
        </el-form>
    </div>
    <div class="table-con">
        <div class="table-con__header">
            <span class="table-con__header-title">商品信息</span>
            <div class="table-con__header-operate">
                <el-button class="table-con__header-button" size="small" @click="openSelectRow" :disabled="!formData.third_lib_id">新增</el-button>
                <el-button class="table-con__header-button" size="small" @click="exportExcel">导出</el-button>
            </div>
        </div>
        <!-- @cell-click="edit" -->
        <el-table :data="formData.goods_list">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="商品名称" prop="name">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.name" ref="iptRef" @blur="inputBlur(scope.row)"></el-input>
                    <span v-else>
                        <span>{{ scope.row.name }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="category_name"></el-table-column>
            <el-table-column label="商品编号" prop="number">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.number" ref="iptRef" @blur="inputBlur(scope.row)"></el-input>
                    <span v-else>
                        <span>{{ scope.row.number }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="重量起始（克）" prop="min_weight">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.min_weight" ref="iptRef" @blur="inputBlur(scope.row)"></el-input>
                    <span v-else>
                        <span>{{ scope.row.min_weight }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="重量结束（克）" prop="max_weight">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.max_weight" ref="iptRef" @blur="inputBlur(scope.row)"></el-input>
                    <span v-else>
                        <span>{{ scope.row.max_weight }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="照片" width="200px">
                <template slot-scope="scope">
                    <upload :fileList.sync="scope.row.image_url" @update:fileList="changeImage(scope.row)"></upload>
                </template>
            </el-table-column>
            <el-table-column label="国际条码" prop="barcode">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.barcode" @blur="inputBlur(scope.row)" ref="iptRef"></el-input>
                    <span v-else>
                        <span>{{ scope.row.barcode }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="售价（元）" prop="real_price">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObj.id === scope.row.id &&
                scopeObj.label === scope.column.label
              " v-model="scope.row.real_price" @blur="inputBlur(scope.row)" ref="iptRef"></el-input>
                    <span v-else>
                        <span>{{ scope.row.real_price }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="独立价格（元）" prop="independent_price">
                <template slot-scope="scope">
                    <el-input v-if="
                scopeObjInd.id === scope.row.id &&
                scopeObjInd.label === scope.column.label
              " v-model="scope.row.independent_price" @blur="inputBlurInd(scope.row)" ref="iptRef"></el-input>
                    <span v-else>
                        <span>{{ scope.row.independent_price }}</span>
                        <i class="el-icon-edit" @click="editInd(scope)" ></i>
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="上机数量" prop="up_count"></el-table-column> -->
            <el-table-column label="单机日均销量" prop="daily_average_sale"></el-table-column>
            <el-table-column label="质期管理">
                <template slot-scope="scope">
                    <el-switch @change="switchisShowOpen(scope.row)" v-model="scope.row.is_open" active-value="STARTED" inactive-value="UNSTART"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="保质天数" prop="exp">
                <template slot-scope="scope">
                    <el-input v-if="
                scope.row.is_open == 'STARTED' &&
                scopeObj.label === scope.column.label &&
                scopeObj.id === scope.row.id
              " v-model="scope.row.exp" @blur="inputBlur(scope.row)" ref="iptRef"></el-input>
                    <span v-else>
                        <span>{{ scope.row.exp }}</span>
                        <i class="el-icon-edit" @click="edit(scope)" v-show="biz_user_id"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="exportData(scope.row)">导出</el-button>
                    <el-button type="danger" size="small" @click="removeItem(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paginationWrap" v-if="this.$route.query.operate === 'look'">
            <!-- <el-pagination @current-change="handleCurrentChange" :current-page="paging"
         :page-size="page_size"
         :page-sizes="[10, 100]"
          layout="total, prev, pager, next" :total="total">
        </el-pagination> -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" :page-sizes="[10, 20,30,50,100]" layout="total,sizes, prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
    <div class="submit-container">
        <el-button type="warning" @click="addNext" v-if="!$route.query.id">提交并继续添加</el-button>
        <el-button type="primary" @click="add" v-if="!isView">提交</el-button>
        <el-button @click="goBack" v-if="!isView">取消</el-button>
    </div>
    <select-group-dialog :show="selectGoodsVisible" @close="closeSelectGoodsDialog" :server="formData.third_lib_id"></select-group-dialog>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SelectGroupDialog from "@/components/SelectGroupDialog";
import upload from "@/components/newUpload";
import apis from "@/config/apis";
import {
    downloadgoods,
    download
} from "@/plugins/util";
export default {
    components: {
        BreadCrumb,
        SelectGroupDialog,
        upload,
    },
    computed: {
        title() {
            // return !this.$route.query.id ? '新增商品分组' : '修改商品分组'
            if (this.$route.query.operate === "look") {
                return "查看商品分组";
            } else {
                if (!this.$route.query.id) {
                    return "新增商品分组";
                } else {
                    return "修改商品分组";
                }
            }
        },
        isView() {
            return this.$route.query.operate === "look";
        },
    },
    data() {
        return {
            biz_user_id: "",
            good_groupId: "",
            mode: "GR",
            pageNum: 1,
            pageSize: 10,
            total: 100,
            shop_name: '',
            selectGoodsVisible: false,
            imgSelect: false,
            formData: {
                name: "",
                third_lib_id: "",
                goods_list: [],
                group_id: this.$route.query.id,
            },
            thirdList: [],
            scopeObj: {
                id: "",
                label: "",
                exp: "",
            },
            scopeObjInd: {
                id: "",
                label: "",
                exp: "",
                goods_group_entry_id: ""
            },
            addCode: false,
            currentRow: null,
            rules: {
                name: {
                    required: true,
                    message: "请输入分组名称",
                },
            },
            oldIndependentPrice: "",
        };
    },
    created() {
        this.getThirdLib();
        if (this.$route.query.id) {
            this.getData();
        }
        this.biz_user_id = localStorage.getItem("user_id") == "42" ? true : false;
        // console.log(this.biz_user_id);
    },

    methods: {
        handleSizeChange(val) {
            // console.log(val,'val')
            this.pageSize = val;
            this.getData();
        },
        reset() {
            this.shop_name = '';
            this.pageNum = 1;
            this.pageSize = 10;
            this.getData();
        },
        // 点击编辑icon图标触发
        edit(scope) {
            // console.log(scope)
            this.scopeObj.id = scope.row.id;
            this.scopeObj.label = scope.column.label;
            this.scopeObj.exp = scope.row.exp;
            this.$nextTick(() => {
                this.$refs.iptRef.focus();
            });
        },
        editInd(scope) {
            // 🔴 原样缓存，不做 Number 转换
            this.oldIndependentPrice = scope.row.independent_price;
            this.scopeObjInd.independent_price = scope.row.independent_price;
            this.scopeObjInd.id = scope.row.id;
            this.scopeObjInd.label = scope.column.label;
            this.scopeObjInd.exp = scope.row.exp;
            this.$nextTick(() => {
                this.$refs.iptRef.focus();
            });

        },
        changeImage(row) {
            this.currentRow = row;
            this.imgSelect = true;
            this.editGoods();
        },
        // 开关提示
        switchisShowOpen(scope) {
            if (scope.is_open == "STARTED") {
                this.$message({
                    message: "开启成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: "关闭成功",
                    type: "success",
                });
            }
        },
        // 失去焦点
        inputBlur(row) {
            this.currentRow = row;
            // this.editGoods();
            this.scopeObj = {
                id: "",
                label: "",
            };
            this.editGoods();
        },
        inputBlurInd(row) {
            const newPrice = row.independent_price;
            const oldPrice = this.oldIndependentPrice; // 保持原样

            // 关闭编辑态
            this.scopeObjInd = {
                id: "",
                label: "",
            };

            // ✅ 没改价格，不做任何事
            if (newPrice === oldPrice) return;

            // 计算差价比例
            const diffRate = Math.abs(newPrice - row.real_price) / row.real_price;

            // 生成提示内容
            let message = `
    <div>如果更改该金额，后续补货新增商品将使用该独立价格。</div>
  `;

            if (diffRate >= 0.2) {
                message += `
      <div style="color:red;margin-top:6px;">
        独立价格与商品定价相差过大，请慎重更改。
      </div>
    `;
            }

            // 弹确认框
            this.$confirm(message, '独立价格修改确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                })
                .then(() => {
                    // 用户确认 → 保存
                    this.currentRow = row;
                    this.editGoodsInd();
                })
                .catch(() => {
                    // 用户取消 → 回滚
                    row.independent_price = oldPrice;
                });
        },

        // 失去焦点
        // inputBlurInd(row) {
        //     this.currentRow = row;
        //     // this.editGoods();
        //     this.scopeObjInd = {
        //         id: "",
        //         label: "",
        //     };
        //     this.editGoodsInd();
        // },
        editGoodsInd() {
            const {
                goods_group_entry_id,
                independent_price,

            } = this.currentRow;
            let data = {
                goods_group_entry_id,
                independent_price: parseFloat(independent_price),
            };
            this.$axios.post(apis.independent_price_change, data).then((res) => {
                if (res.data.code === 200) {
                    this.$message({
                        message: "修改成功",
                        type: "success",
                    });
                } else {
                    this.$message.error("修改失败");
                }
            });
        },
        editGoods() {
            const {
                name,
                image_url,
                number,
                real_price,
                is_view,
                id,
                min_weight,
                max_weight,
                barcode,

            } = this.currentRow;
            let data = {
                name,
                image_url: this.imgSelect == true ? image_url[0].response.url : image_url[0].url,
                //image_url:image_url[0].response.url,
                // image_url:image_url[0].response.url || image_url[0].url ,
                number,
                max_weight,
                real_price,
                independent_price,
                min_weight,
                barcode,
                is_view: true,
                item_id: id,
                // user_id:this.biz_user_id

            };
            this.$axios.post(apis.group_details_goods_update, data).then((res) => {
                if (res.data.code === 200) {
                    this.$message({
                        message: "修改成功",
                        type: "success",
                    });
                } else {
                    this.$message.error("修改失败");
                }
            });
        },
        getThirdLib() {
            this.$axios.get(apis.get_third_lib).then((res) => {
                this.thirdList = res.data.data;
            });
        },
        getData() {
            const loading = this.$loading({
                lock: true,
                text: "数据加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            if (this.$route.query.operate === "look") {
                let jsonData = {
                    page_index: this.pageNum,
                    page_size: this.pageSize,
                    item_name: this.shop_name
                }
                this.$axios
                    .post(`${apis.goods_group_detail}/${this.$route.query.id}`, jsonData)
                    .then((res) => {
                        if (res.data.code == 200) {
                            loading.close();
                        } else {
                            loading.close();
                            this.$message({
                                message: "网速较慢,建议重试!",
                                type: "warning",
                            });
                        }
                        this.good_groupId = res.data.data.id;
                        console.log(this.good_groupId);
                        this.formData.goods_list = res.data.data.entrys;
                        this.page_index = res.data.data.pagination.page_index;
                        this.total = res.data.data.pagination.total_count
                        // this.page_size = res.data.data.pagination.page_count;
                        this.formData.name = res.data.data.name;
                        this.formData.third_lib_id = res.data.data.third_lib_id;
                        this.formData.goods_list.map((item) => {
                            item.image_url = [{
                                name: item.image_url,
                                url: item.image_url,
                            }, ];
                        });
                    });
            } else {
                let jsonData = {
                    tag: 1,
                }
                this.$axios
                    .post(`${apis.goods_group_detail}/${this.$route.query.id}`, jsonData)
                    .then((res) => {
                        if (res.data.code == 200) {
                            loading.close();
                        } else {
                            loading.close();
                            this.$message({
                                message: "网速较慢,建议重试!",
                                type: "warning",
                            });
                        }
                        this.good_groupId = res.data.data.id;
                        console.log(this.good_groupId);
                        this.formData.goods_list = res.data.data.entrys;
                        this.formData.name = res.data.data.name;
                        this.formData.third_lib_id = res.data.data.third_lib_id;
                        this.formData.goods_list.map((item) => {
                            item.image_url = [{
                                name: item.image_url,
                                url: item.image_url,
                            }, ];
                        });
                    });
            }

        },
        handleCurrentChange(page) {
            this.pageNum = page;
            this.getData();
        },
        closeSelectGoodsDialog(data) {
            console.log(data);
            // 多选
            let exist_good = [];
            if (data.length) {
                data.forEach((good) => {
                    let newImage = [{
                        name: good.name,
                        url: good.image_url,
                    }, ];
                    good.exp = 0;
                    good.image_url = newImage;
                    good.item_id = good.id;
                    let isEmpty =
                        this.formData.goods_list.filter((item) => {
                            console.log(item);
                            return item.id === good.id || item.number === good.number;
                        }).length === 0;
                    if (isEmpty) {
                        this.formData.goods_list.push(good);
                    } else {
                        exist_good.push(good.name);
                    }
                });
                if (exist_good.length) {
                    this.$message({
                        type: "error",
                        message: `${exist_good.join(",")}已存在`,
                    });
                }
            }

            // if(data.length) {
            //   data.forEach(good=> {
            //     let newImage = [{
            //       name: good.image_url,
            //       url: good.image_url
            //     }]
            //     good.image_url = newImage;
            //     good.item_id = good.id;
            //     let isEmpty = this.formData.goods_list.filter(item => {
            //       return item.id === good.id || item.number === good.number;
            //     }).length === 0;
            //     if (isEmpty) {
            //       this.formData.goods_list.push(good);
            //     } else {
            //       exist_good.push(good.name)
            //     }
            //   })
            //   if(exist_good.length) {
            //     this.$message({
            //       type: "error",
            //       message: `${exist_good.join(',')}已存在`
            //     });
            //   }

            //   this.addCode = true;
            // }

            // 单选
            // if (data.id) {
            //   data.item_id = data.id;
            //   let isEmpty = this.formData.goods_list.filter(item => {
            //     return item.id === data.id || item.number === data.number;
            //   }).length === 0;
            //   if (isEmpty) {
            //     this.formData.goods_list.push(data);
            //   } else {
            //     this.$message({
            //       type: "error",
            //       message: "已存在相同商品"
            //     });
            //   }
            // }

            this.selectGoodsVisible = false;
        },
        // 新增
        openSelectRow() {
            // console.log(this.formData);
            this.selectGoodsVisible = true;
        },
        // 分组数据总导出
        exportExcel() {
            const loading = this.$loading({
                lock: true,
                text: "导出下载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            download(
                    this,
                    apis.goods_group_detail + "/" + this.good_groupId,
                    "商品分组导出数据.xls",
                    "post", {
                        export: true
                    }
                )
                .then(() => {
                    loading.close();
                })
                .catch(() => {
                    loading.close();
                    // alert('选择数据过多,下载超时，建议重新选择数据下载')
                    this.$message({
                        message: "数据过多或网速较慢,下载超时，建议重新导出下载!",
                        type: "warning",
                    });
                });
        },
        // 导出
        exportData(row) {
            // console.log(row);
            if (row.item_id !== "") {
                downloadgoods(
                    this,
                    apis.export_goods_record + "/" + row.item_id,
                    "商品十五日销售详情.xls"
                );
            } else {
                downloadgoods(
                    this,
                    apis.export_goods_record + "/" + row.id,
                    "商品十五日销售详情.xls"
                );
            }
        },
        removeItem(index) {
            this.formData.goods_list.splice(index, 1);
        },
        // 提交并继续添加
        addNext() {
            let _this = this;
            this.save(function () {
                _this.formData.name = "";
                _this.formData.goods_list = [];
                _this.formData.is_open = "";
                _this.formData.exp = "";
            });
        },
        // 提交
        add() {
            let _this = this;
            this.save(function () {
                _this.goBack();
            });
        },
        // 切换服务器时，清空商品列表

        clearGoodsList() {
            if (!this.$route.query.id) {
                this.formData.goods_list = [];
            }
        },
        save(fun) {
            // console.log(11);
            this.$refs.form.validate((valid) => {
                console.log(11, valid);
                if (valid) {
                    let {
                        goods_list,
                        ..._data
                    } = this.formData;
                    if (this.$route.query.id) {
                        let newGoodsList = JSON.parse(JSON.stringify(goods_list));
                        newGoodsList.map((item) => {
                            let image_url = item.image_url[0].response ?
                                item.image_url[0].response.url :
                                item.image_url[0].url;
                            item.image_url = image_url;
                        });
                        _data.goods_list = newGoodsList;
                        _data.is_view = true;
                        this.$axios.post(apis.goods_group_update, _data).then((res) => {
                            console.log(_data, res);
                            if (res.data.code === 200) {
                                fun();
                            }
                        });
                    } else {
                        _data.goods_list = [];
                        goods_list.forEach((item) => {
                            _data.goods_list.push(item.id);
                        });
                        // for (let i = 0; i < _data.goods_list.length; i ++) {
                        //   let item = _data.goods_list[i]
                        //   console.log(item)
                        //   let isKey = Object.keys(item).find(item => item === "exp")
                        //   if (isKey) {
                        //     _data.goods_list.splice(i, 1)
                        //     i --;
                        //   }
                        // }
                        this.$axios.post(apis.goods_group_add, _data).then((res) => {
                            if (res.data.code === 200) {
                                fun();
                            }
                        });
                        // this.addCode = false
                    }

                    // if (this.$route.query.id) {
                    //   //update
                    //   _data.is_view = true;
                    //   this.$axios.post(apis.goods_group_update, _data).then(res => {
                    //     if (res.data.code === 200) {
                    //       fun();
                    //     }
                    //   })
                    // } else {
                    //   //add
                    //   this.$axios.post(apis.goods_group_add, _data).then(res => {
                    //     if (res.data.code === 200) {
                    //       fun();
                    //     }
                    //   })
                    // }
                }
            });
        },
        goBack() {
            this.$router.push({
                name: "goodsGroup",
            });
        },
    },
};
</script>

<style scoped>
.submit-container {
    margin-top: 60px;
}

.el-icon-edit {
    cursor: pointer;
}
</style>
